import { enableTrace } from '@/util/env'

const DEFAULT_LOGGER = {
  debug: console.debug ? console.debug.bind(console) : console.log.bind(console),
  info: console.info ? console.info.bind(console) : console.log.bind(console),
  warn: console.warn ? console.warn.bind(console) : console.log.bind(console),
  error: console.error ? console.error.bind(console) : console.log.bind(console)
}

const enable = enableTrace === 'true'

class DiagnosticsChannel {
  constructor(manager, name) {
    this.manager = manager
    this.name = name
  }

  log(level, event, payload) {
    if (!enable) return
    const loggerFn = DEFAULT_LOGGER[level] ?? DEFAULT_LOGGER.info
    loggerFn(`[diagnostics:${this.name}] ${event}`, payload)
  }

  debug(event, payload) {
    if (!enable) return
    this.log('debug', event, payload)
  }

  info(event, payload) {
    if (!enable) return
    this.log('info', event, payload)
  }

  warn(event, payload) {
    if (!enable) return
    this.log('warn', event, payload)
  }

  error(event, payload) {
    if (!enable) return
    this.log('error', event, payload)
  }
}

class DiagnosticsManager {
  constructor() {
    this.channels = new Map()
  }

  createChannel(name) {
    if (this.channels.has(name)) return this.channels.get(name)
    const channel = new DiagnosticsChannel(this, name)
    this.channels.set(name, channel)
    return channel
  }

  getChannel(name) {
    return this.channels.get(name)
  }
}

const diagnosticsManager = new DiagnosticsManager()

export { DiagnosticsManager, DiagnosticsChannel, diagnosticsManager }
export default diagnosticsManager
